export function nearestEvenInt(num: number): number {
  return 2 * Math.round(num / 2)
}
